import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';
import { PublicTeacherDto, TeacherInquiryCreateDto, TeacherSearchQueryDto } from '../models/public-teacher';
import { TenantSignupRequestCreateDto } from '../models/tenant-signup';

@Injectable({ providedIn: 'root' })
export class PublicPortalService {
  private baseUrl = `${environment.apiUrl}/PublicPortal`;

  constructor(private http: HttpClient) {}

  searchTeachers(query: TeacherSearchQueryDto): Observable<ApiResponse<PublicTeacherDto[]>> {
    let params = new HttpParams()
      .set('radiusKm', query.radiusKm ?? 25)
      .set('pageNumber', query.pageNumber ?? 1)
      .set('pageSize', query.pageSize ?? 20);

    if (query.latitude != null)  params = params.set('latitude',  query.latitude);
    if (query.longitude != null) params = params.set('longitude', query.longitude);
    if (query.subject)           params = params.set('subject',   query.subject);

    return this.http.get<ApiResponse<PublicTeacherDto[]>>(`${this.baseUrl}/SearchTeachers`, { params });
  }

  getTeacherProfile(id: string): Observable<ApiResponse<PublicTeacherDto>> {
    return this.http.get<ApiResponse<PublicTeacherDto>>(`${this.baseUrl}/GetTeacherProfile/${id}`);
  }

  sendInquiry(dto: TeacherInquiryCreateDto): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.baseUrl}/SendInquiry`, dto);
  }

  submitTenantSignup(dto: TenantSignupRequestCreateDto): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.baseUrl}/SubmitTenantSignup`, dto);
  }
}
